import { useApolloClient } from '@apollo/client'

import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import { signOutAndRedirectToCountryDomain } from 'modules/core/lib/signOutAndRedirectToCountryDomain'

const SignOutPage = () => {
  const client = useApolloClient()

  useEffect(() => {
    const signout = async () => {
      client.clearStore()
      signOutAndRedirectToCountryDomain()
    }
    signout()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <Loading />
}

export default SignOutPage
